import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  InputProps,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useDebounce } from '../../hooks/useDebounce';
import { SearchIcon } from '../../icons';
import { eliminateHtmlTags } from '../../shared/utils';

interface Props extends InputProps {
  searchValue: string;
  setSearchValue: (value: string) => void;
  placeholder?: string;
  includeIcon?: boolean;
}

export function SearchInputBar({
  searchValue,
  setSearchValue,
  placeholder,
  includeIcon = true,
  size,
  ...props
}: Props) {
  const [searchTerm, setSearchTerm] = useState<string>(searchValue);
  const debouncedSearchTerm = useDebounce(searchTerm);

  useEffect(() => {
    setSearchValue(debouncedSearchTerm);
  }, [debouncedSearchTerm]);

  useEffect(() => {
    if (searchValue === '') {
      setSearchTerm('');
    }
  }, [searchValue]);

  return (
    <Box {...props}>
      <Flex justify={'center'} align={'center'}>
        <InputGroup>
          {includeIcon && (
            <InputLeftElement pointerEvents="none" pb={2}>
              <SearchIcon height={'14px'} width="14px" />
            </InputLeftElement>
          )}
          <Input
            id="input"
            name="input"
            size={size || 'sm'}
            placeholder={placeholder || ''}
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(eliminateHtmlTags(e.target.value));
            }}
          />
        </InputGroup>
      </Flex>
    </Box>
  );
}

export default SearchInputBar;
